export default __webpack_public_path__ + "1fb388e14b7fe2ef1f437d71326b33ab.svg";